import PronounceMP3 from "../../assets/audio/faqPronounce_la.mp3";
import PronounceOGG from "../../assets/audio/faqPronounce_la.ogg";

const faqStrings = {
  sections: [
    {
      title: "General",
      data: [
        {
          question: "¿Qué es ABCya?",
          answer: `<p>ABCya ofrece más de <strong>100 juegos divertidos </strong> y <strong>educativos</strong> para los grados <strong>que van desde preescolar hasta sexto</strong>. Nuestras actividades están diseñadas por padres y educadores, es decir, por aquellos que saben que los niños aprenden mejor cuando se divierten. Los jóvenes estudiantes disfrutarán al mismo tiempo que trabajan con las Pelusitas para <a href="/juegos/pelusitas-contar-clasificar-y-comparar">contar, clasificar y comparar.</a>  También se divertirán con murciélagos amigables al mismo tiempo que <a href="/juegos/murcieletras-silabas">practican contar sílabas de palabras</a>.</p>
          <p>Más de <strong>100 millones de niños utilizan ABCya todos los años</strong> en infinidad de aulas y hogares de todo el mundo. Nuestras actividades están clasificadas por grado y por asignatura y cubren temas como la multiplicación, las categorías gramaticales, la mecanografía, el reconocimiento de patrones y muchas otras cosas. ¡Incluimos asimismo juegos que son sencillamente divertidos (y seguros) de jugar! Con tal variedad, no cabe duda de que ABCya tiene algo que ofrecer a niños de todos los niveles y estilos de aprendizaje.</p>
          <p>Cada semana, ofrecemos una nueva selección de juegos para jugar gratis sin límite, ¡así que siempre hay algo divertido por descubrir en ABCya! Disfruta de estos juegos de ABCya GRATIS, o adquiere tu membresía para obtener acceso ilimitado a más de 100 juegos que hacen que el aprendizaje sea emocionante para tu hijo.</p>`,
        },
        {
          question: "¿Cómo se pronuncia ABCya?",
          answer: `<p>El nombre del sitio web se pronuncia "a", "be", "ce", "ya".</p><button id="pronounceBtn" type="button" class="button-flat-color pt-blue round auto">¡Haz clic aquí para escucharlo!</button>
          <audio id="pronounceAudio">
            <source src="${PronounceOGG}" type="audio/ogg">
            <source src="${PronounceMP3}" type="audio/mpeg">
            Tu navegador no es compatible con el elemento de audio.
          </audio>`,
        },
        {
          question: "¿Qué pasa si olvido mi contraseña?",
          answer: `<p>Si no recuerdas tu contraseña, puedes restablecerla en cualquier momento en nuestra página “Olvidé mi contraseña”.</p>
          <p><a href="/restablecer-contrasena">Haz clic aquí para restablecer tu contraseña.</a></p>`,
        },
      ],
    },
    {
      title: "Suscripción",
      data: [
        {
          question: "¿Ofrece ABCya una prueba gratuita?",
          answer: `<p>Si deseas probar los juegos de ABCya antes de suscribirte, puedes disfrutar de nuestra selección de juegos gratuitos que cambian cada semana. Para ello, visita la página la.abcya.com.</p>
          <p>Para desbloquear nuestra colección completa de más de 100 juegos, se requiere una suscripción.</p>`,
        },
        {
          question: "¿Cómo cancelo mi suscripción?",
          answer: `<p>Para cancelar tu suscripción, asegúrate primero de haber iniciado sesión en tu cuenta. A continuación, visita la página <a href="/iniciar-sesion?ruta=administrar">Administrar cuenta</a> y sigue los pasos allí indicados para cancelar o administrar tu suscripción.</p>`,
        },
        {
          question: "¿Cómo elimino toda mi información de ABCya.com?",
          answer: `<p>Para eliminar toda tu información de ABCya.com, asegúrate primero de haber iniciado sesión en tu cuenta.</p>
          <p>A continuación, visita la página <a href="/administrar">Administrar cuenta</a>. Haz clic en el botón rojo "Eliminar cuenta" de dicha página y sigue los pasos allí indicados para eliminar tu información.</p>
          <p><strong>TEN EN CUENTA QUE SI TIENES UNA SUSCRIPCIÓN PAGADA ACTIVA, TENDRÁS QUE CANCELARLA PRIMERO. Podrás eliminar tu información después de que la suscripción haya terminado.</strong></p>
          <p>Si necesitas que tu información sea eliminada antes de que tu suscripción termine, por favor ponte en contacto con el servicio al cliente de ABCya en soporte@abcya.com. Estaremos encantados de ayudarte.</p>
          <p><strong>Una vez eliminada tu cuenta, tu información se borrará de nuestra base de datos de forma permanente e inmediata y no podrás iniciar sesión.</strong></p>`,
        },
        {
          question: "¿Cuáles son los beneficios de tener una suscripción?",
          answer: `<p>Los suscriptores disfrutan de todos los beneficios de la membresía a ABCya:
          <ul>
          <li>acceso a nuestra colección completa de más de 100 juegos</li>
          <li>acceso a cientos de hojas de ejercicios, páginas de actividades y recursos para docentes de ABCya</li>
          <li>un número ilimitado de juegos guardados como favoritos</li>
          <li>acceso a herramientas como el temporizador, el control de categorías y el modo de juego en pantalla completa</li>
          </ul></p>`,
        },
        /* {
          question: "Cuáles son los beneficios de crear una cuenta gratuita?",
          answer: `<p>Con una cuenta gratuita, puedes guardar 3 juegos favoritos, desbloquear todos los imprimibles gratuitamente, recibir el email informativo sobre el juego de la semana, y recibir en exclusividad emails sobre todas las novedades de ABCya.</p>`,
        }, */
        {
          question: "¿Puedo comprar suscripciones de clase mediante orden de compra?",
          answer: `Sí, aceptamos órdenes de compra para suscripciones de clase. Para solicitar un presupuesto formal, por favor, contacta con nosotros en <a href="mailto:sales@abcya.com">sales@abcya.com</a>.`,
        },
      ],
    },
    {
      title: "Técnico",
      data: [
        {
          question: "¿Qué navegadores son compatibles con ABCya.com?",
          answer: `<p>ABCya.com es compatible con las versiones actuales de los navegadores web Safari, Chrome, Firefox y Edge.</p>`,
        },
        {
          question: "¿Por qué no puedo iniciar sesión?",
          answer: `<p>En primer lugar, asegúrate de que utilizas la información correcta para el inicio de sesión.</p>
          <p>Si no recuerdas tu contraseña, por favor haz clic <a href="/restablecer-contrasena">aquí</a> para restablecerla.</p>
          <p>Si sigues teniendo problemas para iniciar sesión, no dudes en ponerte en contacto con el servicio al cliente de ABCya en <a href="mailto:soporte@abcya.com" rel="noopener noreferrer" target="_blank">soporte@abcya.com</a>. ¡Estaremos encantados de ayudarte!</p>`,
        },
        {
          question: "¿Por qué faltan algunas categorías en las páginas de nivel de grado?",
          answer: `<p>Si faltan categorías en las páginas de nivel de grado, inicia sesión en tu cuenta, visita la página <a href="/herramientas">Herramientas</a> y vuelve a activar las categorías que faltaban.</p>`,
        },
        {
          question: "¿Por qué no puedo encontrar un juego que estaba antes en ABCya?",
          answer: `<p>Es posible que el juego que buscas fuera creado con Adobe Flash. En enero del 2021, Adobe Flash dejó de ser compatible con nuestro sitio web, por lo que, desafortunadamente, hay juegos que ya no están disponibles. Puedes explorar más de 100 excelentes actividades educativas <a href="/juegos/">aquí</a>.</p>`,
        },
      ],
    },
    {
      title: "Herramientas",
      data: [
        {
          question: "¿Cómo funciona el temporizador?",
          answer: `<p>La herramienta “Temporizador” te permite programar un temporizador en función de la cantidad de tiempo que quieres que tu hijo pase en ABCya. Cuando el tiempo programado llegue a su fin, tu hijo recibirá un mensaje emergente informándole de que su tiempo ha finalizado.</p>
          <p>Ten en cuenta que el temporizador no impide que el usuario siga jugando, sino que se limita a enviarle un mensaje emergente para recordarle amablemente que su tiempo de juego ha terminado.</p>
          <p>El temporizador no se pone en marcha de forma automática en todos los dispositivos asociados a tu cuenta. Tendrás que configurarlo manualmente en cada dispositivo.</p>`,
        },
        {
          question: "¿Cuántos juegos favoritos puedo tener en mi cuenta?",
          answer: `<p>El número de juegos favoritos que puedes guardar depende de tu tipo de cuenta.</p>
          <p>Con una cuenta gratuita, puedes guardar hasta 3 juegos favoritos.</p>
          <p>Con una suscripción, puedes guardar un número ilimitado de juegos favoritos.</p>`,
        },
        {
          question: "¿Cómo funciona el control de categorías?",
          answer: `<p>El control de categorías permite a los usuarios activar o desactivar las diferentes categorías de juegos (por ejemplo, juegos de letras, números, estrategia, etc.) dentro de las páginas de nivel de grado, permitiendo así a padres y docentes ejercer un mayor control sobre aquello a lo que los niños tienen acceso.</p>
          <p><strong>Por favor, ten en cuenta que quizá necesites actualizar tu navegador tras activar o desactivar una categoría a fin de poder visualizar el cambio.</strong></p>`,
        },
        {
          question: "¿Cómo funciona el modo de pantalla completa?",
          answer: `<p>En los juegos de ABCya, el modo de pantalla completa está disponible para los suscriptores. Para activar el modo de pantalla completa, haz clic en el botón "Pantalla completa" situado sobre el juego. Si quieres salir del modo de pantalla completa, haz clic en el botón "X" que aparece en la parte superior derecha de la pantalla o pulsa la tecla "ESC" de tu teclado.</p>`,
        },
      ],
    },
    {
      title: "Apps",
      data: [
        {
          // should be first index (0) so we aren't always
          // having to change it in routes redirect '/config/routes'
          question: "¿Ofrece ABCya apps móviles?",
          answer: `¡Consulta nuestra oferta de apps móviles <a href="/oferta-de-productos">aquí</a>!`,
        },
      ],
    },
  ],
};

export default faqStrings;
